import(/* webpackMode: "eager" */ "/app/src/app/(landing)/faq/page.tsx");
